import React, { useRef, useState } from "react";
import { Icon } from "@iconify/react";
import "./ProjectTabContent.css";
import { useAuth } from "../../Context/UserContext";
import { RetestRequestSideBar } from "../../Client-components/Modal/RetestRequestSideBar";
import TeamCard from "./TeamCard";
import { useEffect } from "react";
import target from '../../Assests/taskimage.png'
import { url } from "../../constants/url";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import CustomSelect from "../Pages/Custom_Functions/CustomSelect";
import { Link, useNavigate } from "react-router-dom";
import DeleteReport from "./Delete";

function ProjectTabContent({ tab, singleProjectData, singleProjectVulnerability, selectedProjectDetails }) {


  const [vulnerabilities, setVulnerabilities] = useState(singleProjectVulnerability || []);

  useEffect(() => {
    setVulnerabilities(singleProjectVulnerability || []);
  }, [singleProjectVulnerability]);

  console.log(singleProjectVulnerability)

  // this is  states 
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedVulId, setSelectedVulId] = useState(null);

  const { userRole, logout } = useAuth();
  const [retestRequest, setRetestRequest] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [rows, setRows] = useState([]);
  const [scopeFileName, setScopeFileName] = useState('')
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const [severityCount, setSeverityCount] = useState({
    Critical: 0,
    High: 0,
    Medium: 0,
    Low: 0,
    Info: 0
  })
  const [retestCount, setRetestCount] = useState({
    Fixed: 0,
    Not_Fixed: 0,
    NA: 0
  })

  const [testersData, setTestersData] = useState([])
  const [openAddPentester, setOpenAddPentester] = useState(false)
  const [suggestions, setSuggestions] = useState([])
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [penTesters, setPenTesters] = useState('')
  const [loading, setLoading] = useState(false)
  const [isEditing, setIsEditing] = useState(false)
  const [isRetestEditing, setIsRetestEditing] = useState(false)
  const [selectedOption, setSelectedOption] = useState('')
  const [retestSelectedOption, setRetestSelectedOption] = useState('')
  const [editingVulId, setEditingVulId] = useState(null);
  const [buttonVisible, setButtonVisible] = useState(true);
  const [confirmDelete, setConfirmDelete] = useState(false)
  const [selectedFileName, setSelectedFileName] = useState(null);

  const suggestionsRef = useRef(null);
  const inputRef = useRef(null)
  const statusRef = useRef()

  const [file, setFile] = useState(null);
  const [allDoc, setAllDoc] = useState([]);
  // const [buttonVisible, setButtonVisible] = useState(true);
  const [isButtonVisible, setIsButtonVisible] = useState(true);
  const [dragging, setDragging] = useState(false);
  const fileTypes = ['application/pdf', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];

  const navigate = useNavigate()

  const formatDate = (dateString) => {
    const options = { day: "2-digit", month: "2-digit", year: "numeric" };
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", options);
  };

  const getStatus = (status) => {
    if (status === 'Inprogress') {
      return 'inprogress';
    } else if (status === 'Retesting') {
      return 'retesting';
    } else if (status === "Completed") {
      return 'completed_status';
    }
  };

  const getScopeStatus = (status) => {
    if (status === 'Inprogress') {
      return 'inprogress_scope';
    } else if (status === 'Retesting') {
      return 'retesting_scope';
    } else if (status === "Completed") {
      return 'completed_scope';
    }
  };

  // this is delete Vulnerability 
  const handleDeleteVulnerability = async () => {
    try {
      const response = await fetch(`${url}/deletevulnerability`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({
          vulId: selectedVulId,
        }),
      });

      if (response.status === 440) {
        logout();
        toast.error("User logout due to inactivity");
        return;
      }


      if (!response.ok) {
        const err = await response.json();
        toast.error(err.message || "Failed to delete vulnerability");
        return;
      }

      setVulnerabilities(prev =>
        prev.filter(vul => vul._id !== selectedVulId)
      );
      toast.success("Vulnerability deleted successfully");

      setDeleteModalOpen(false);
      setSelectedVulId(null);


      // fetchVulnerability();

    } catch (error) {
      console.error(error);
      toast.error("Something went wrong");
    }
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    setDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const selectedFile = e.dataTransfer.files[0];
    setFile(selectedFile);
  };

  const handleFileInputChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
  };

  const handleEditClick = () => {
    setIsEditing(true);
    setButtonVisible(false);
  };

  const handleRetestEditClick = (vulId) => {
    setEditingVulId(vulId);
  };

  const handleEditVulnerability = async (id) => {
    navigate(`/isecurion_dash/status/${singleProjectData?._id}/addvuln?vulId=${id}`);
  }

  const handleEmployeeChange = (e) => {
    const input = e.target.value;
    setPenTesters(input);
    const filtered = suggestions.filter((name) =>
      name.toLowerCase().includes(input.toLowerCase())
    );
    setFilteredSuggestions(filtered);
  };

  const handleSuggestionClick = (suggestion) => {
    setPenTesters(suggestion);
    setFilteredSuggestions([]);
  };

  const diffToast = () => {
    toast.success("Project status updated...", {
      position: "top-right",
      autoClose: 2500,
      pauseOnHover: false,
    });
  };

  const diffToastError = () => {
    toast.error("You have not selected any option", {
      position: "top-right",
      autoClose: 2500,
      pauseOnHover: false,
    });
  };

  const diffToastErrorstatus = () => {
    toast.error("Failed to update project status", {
      position: "top-right",
      autoClose: 2500,
      pauseOnHover: false,
    });
  };

  const diffToastErrorUploadDoc = () => {
    toast.success("Document uploaded successfully...", {
      position: "top-right",
      autoClose: 2500,
      pauseOnHover: false,
    });
  };

  const diffToastFileError = () => {
    toast.error('Only "pdf", "Excel sheet" files are allowed', {
      position: "top-right",
      autoClose: 2500,
      pauseOnHover: false,
    });
  };

  const addProjectSuccess = () => {
    toast.success("Retest status updated...", {
      position: "top-right",
      autoClose: 2500,
      pauseOnHover: false,
    });
  };

  const fetchNetworkScope = async (projectId) => {
    try {
      const response = await fetch(`${url}/projectscopedetails?projectId=${projectId}`, {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
        },
        credentials: 'include',
      });
      const data = await response.json()
      fetchNetworkScopeContent(projectId, data.file.fileName)
      setScopeFileName(data.file.fileName)

    } catch (error) {
      console.error("Error fetching scope:", error);
    }
  }

  const fetchNetworkScopeContent = async (projectId, fileName) => {
    try {
      const response = await fetch(`${url}/pojectscopecontentdetails`, {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        credentials: 'include',
        body: JSON.stringify({ projectId, fileName })
      })
      if (!response.ok) {
        throw new Error("Failed to fetch content");
      }

      const data = await response.json();
      if (data && Array.isArray(data)) {
        setRows(data);
      } else {
        setRows([])
      }

    } catch (error) {
      console.log(error)
    }
  }

  const previewRows = Array.isArray(rows) ? rows.slice(0, 2) : [];

  const previewCols =
    rows && rows.length > 0 && rows[0] && typeof rows[0] === "object"
      ? Object.keys(rows[0] || {}).slice(0, 3)
      : [];

  const vulCount = () => {
    if (!singleProjectVulnerability || !Array.isArray(singleProjectVulnerability)) return;
    const count = singleProjectVulnerability.reduce(
      (acc, vuln) => {
        const severity = vuln.severity;
        if (acc[severity] !== undefined) {
          acc[severity] += 1;
        }
        return acc;
      },
      { Critical: 0, High: 0, Medium: 0, Low: 0, Info: 0 }
    );

    setSeverityCount(count);
  }

  const restestCount = () => {
    if (!singleProjectVulnerability || !Array.isArray(singleProjectVulnerability)) return;

    const count = singleProjectVulnerability.reduce(
      (acc, vuln) => {
        let retestStatus = vuln.retestStatus?.trim();

        // Normalize possible variations
        if (retestStatus === "Not Fixed") {
          retestStatus = "Not_Fixed";
        } else if (retestStatus === "Fixed") {
          retestStatus = "Fixed";
        } else if (retestStatus === "NA") {
          retestStatus = "NA";
        } else {
          return acc
        }

        if (acc[retestStatus] !== undefined) {
          acc[retestStatus] += 1;
        }

        return acc;
      },
      { Fixed: 0, Not_Fixed: 0, NA: 0 }
    );

    setRetestCount(count);
  };

  const fetchPentesterDetails = async () => {
    try {
      const response = await fetch(`${url}/getpentesters?projectId=${singleProjectData?._id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'include'
      })
      const testersDetails = await response.json()

      setTestersData(testersDetails)
    } catch (error) {
      console.log(error)
    }
  }

  const fetchEmployeeName = async () => {
    try {
      const response = await fetch(`${url}/fetchemployeedetails`, {
        method: "GET",
        credentials: 'include'
      })
      const employeeData = await response.json()
      setSuggestions(employeeData)
    } catch (error) {
      console.log(error)
    }
  }

  const handlePentesters = async () => {
    setLoading(true)
    if (penTesters === '') {
      setLoading(false)
      return
    }
    try {
      const response = await fetch(`${url}/addpentesters`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        credentials: 'include',
        body: JSON.stringify({
          pentesters: penTesters,
          projectid: singleProjectData._id
        })
      })
      if (response.ok) {
        toast.success("Pentesters added successfully", {
          position: "top-right",
          autoClose: 2500,
          pauseOnHover: false,
        });
        setPenTesters('')
        setLoading(false)
        setOpenAddPentester(false)
        fetchPentesterDetails()
        return
      }
      if (response.status === 400) {
        toast.error("Project access already given ", {
          position: "top-right",
          autoClose: 2500,
          pauseOnHover: false,
        });
        setLoading(false)
        return
      }
      if (response.status === 403) {
        toast.error(`${penTesters} is a Manager`, {
          position: "top-right",
          autoClose: 2500,
          pauseOnHover: false,
        });
        setLoading(false)
        return
      }
      if (response.status === 422) {
        toast.error('User is not registered', {
          position: "top-right",
          autoClose: 2500,
          pauseOnHover: false,
        });
        setLoading(false)
        return
      }
      if (response.status === 404) {
        toast.error("Pentester not found ", {
          position: "top-right",
          autoClose: 2500,
          pauseOnHover: false,
        });
        setLoading(false)
        return
      }
      if (response.status === 401) {
        toast.error("Unauthorized", {
          position: "top-right",
          autoClose: 2500,
          pauseOnHover: false,
        });
        setLoading(false)
        return
      }
      if (response.status === 500) {
        toast.error("Internal Server Error", {
          position: "top-right",
          autoClose: 2500,
          pauseOnHover: false,
        });
        setLoading(false)
        return
      }
    } catch (error) {
      console.log(error)
      toast.error(error.response.data.message, {
        position: "top-center",
        autoClose: 5000,
        pauseOnHover: false,
      });
      // setIsButtonVisible(true)
      setLoading(false)
    }
  }

  const handleSaveClick = async (id, newStatus) => {
    try {
      const response = await fetch(`${url}/updateprojectstatus`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({
          projectId: id,
          status: newStatus,
        }),
      });
      console.log('Update Response:', response);

      if (response.status === 200) {
        const result = await response.json();

        console.log(result)

        diffToast();
        selectedProjectDetails(result._id)

        setIsEditing(false);
        setSelectedOption('');

        setTimeout(() => {
          setIsEditing(false);
          setButtonVisible(true);
        }, 2000);
      }
      if (response.status === 304) {
        toast.error("Please select a different status", {
          position: "top-right",
          autoClose: 2500,
          pauseOnHover: false,
        });
      }
    } catch (error) {
      console.error('Failed to update project status:', error);
      diffToastErrorstatus();
    }
  };

  const handleFileUpload = async (e) => {
    e.preventDefault();
    try {
      if (fileTypes.includes(file.type)) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('projectId', singleProjectData._id);

        const response = await fetch(`${url}/uploaddocument`, {
          method: "POST",
          body: formData,
          headers: {
            'Accept': 'application/pdf, application/vnd.ms-excel',
          },
          credentials: 'include'
        })
        if (response.status === 403 || response.status === 400) {
          toast.error("Invalid File", {
            position: "top-right",
            autoClose: 2500,
            pauseOnHover: false,
          });
          return
        }
        if (response.status === 440) {
          logout()
          toast.error("User logout due to inactivity", {
            position: 'top-right',
            autoClose: 2500,
            pauseOnHover: false,
          });
          return
        }
        if (response.ok) {
          diffToastErrorUploadDoc()
          setFile(null)
          fetchDocument();
        }
      } else {
        diffToastFileError()
        setDragging(false)
        setTimeout(() => {
          setFile(null);
        }, 1500)
      }
    } catch (error) {

      console.error('Error adding file:', error.response ? error.response.data : error.message);
    }
  }

  const fetchDocument = async () => {
    try {
      const response = await fetch(`${url}/fetchdocument?projectId=${singleProjectData._id}`, {
        method: 'GET',
        credentials: 'include'
      });

      if (!response.ok) {
        throw new Error('Failed to fetch documents');
      }

      const text = await response.text(); // get raw response
      const data = text ? JSON.parse(text) : []; // parse only if not empty
      setAllDoc(data);

    } catch (error) {
      console.error('Error fetching documents:', error);
    }
  };

  const handleReportDownload = async (filename) => {
    try {
      const response = await fetch(`${url}/reportdownload/${filename}?projectId=${singleProjectData._id}`, {
        method: 'GET',
        credentials: 'include'
      });
      if (!response.ok) {
        throw new Error('Failed to fetch file');
      }
      const blob = await response.blob();
      const fileUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = fileUrl;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
      console.error('Error downloading file:', error);
    }
  };

  const handleRetestSave = async (documentId, option) => {
    setEditingVulId(null)
    try {
      const response = await fetch(`${url}/updatereteststatus`, {
        method: "PUT",
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({
          vulnerabilityId: documentId,
          selectedOption: option
        })
      });
      if (response.status === 440) {
        logout()
        toast.error("User logout due to inactivity", {
          position: 'top-right',
          autoClose: 2500,
          pauseOnHover: false,
        });
        return
      }
      if (response.status === 200) {
        const result = await response.json();
        setVulnerabilities(singleProjectVulnerability || [])
        setEditingVulId(null)
        addProjectSuccess();
        selectedProjectDetails()
        // selectedProjectDetails()
      } else {
        const errorResult = await response.json();
        console.error(errorResult.message);
        toast.error(errorResult.message, {
          position: "top-right",
          autoClose: 2500,
          pauseOnHover: false,
        });
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    vulCount()
    restestCount()
    fetchEmployeeName()
    fetchDocument()

  }, [singleProjectVulnerability])

  useEffect(() => {
    if (
      singleProjectData?.applicationType &&
      [
        "VA Scan",
        "Configuration Review",
        "External Network Penetration Testing",
        "Internal Network Penetration Testing",
      ].includes(singleProjectData?.applicationType)
    ) {
      fetchNetworkScope(singleProjectData._id);

    }
  }, [singleProjectData?.applicationType]);

  useEffect(() => {
    if (singleProjectData && singleProjectData._id) {
      fetchPentesterDetails();
    }
  }, [singleProjectData]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (statusRef.current && !statusRef.current.contains(event.target)) {
        setIsEditing(false);
        setButtonVisible(true)
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isEditing]);




  switch (tab) {
    case "overview":
      return userRole === "manager" ? (
        <>
          {/* manager overview */}
          <div className="isecurion_single_project_manager_overview_and_matrix_container">
            <div className="isecurion_single_project_manager_overview_container">
              <div>
                {window.location.pathname.startsWith('/projects/status') ? (
                  <div className="isecurion_single_project_manager_overview_heading">
                    {singleProjectData?.projectName}
                  </div>
                ) : (
                  <div className="isecurion_single_project_manager_overview_heading">
                    Project Overview
                  </div>
                )}
              </div>
              <div style={{ display: "flex", flexDirection: 'row', justifyContent: 'space-between' }}>
                <div style={{ marginTop: "-10px" }}>
                  <div className="isecurion_single_project_manager_overview_items">
                    Client Name: {singleProjectData?.clientName}
                  </div>
                  <div className="isecurion_single_project_manager_overview_items">
                    Application Type : {singleProjectData?.applicationType}
                  </div>
                  <div className="isecurion_single_project_manager_overview_items">
                    Audit Lead : {singleProjectData?.teamLead}
                  </div>
                  <div className="isecurion_single_project_manager_overview_items">
                    Client Lead : {singleProjectData?.clientManagerName}
                  </div>
                  <div className="isecurion_single_project_manager_overview_items">
                    Client Type : {singleProjectData?.clientType}
                  </div>
                  <div className="isecurion_single_project_manager_overview_items">
                    Environment Type : {singleProjectData?.environmentType}
                  </div>
                  <div className="isecurion_single_project_manager_overview_items">
                    Report Type : {singleProjectData?.projectType}
                  </div>
                  <div className="isecurion_single_project_manager_overview_items">
                    Test Start Date: {formatDate(singleProjectData?.testStartDate)}
                  </div>
                  <div className="isecurion_single_project_manager_overview_items">
                    Test End Date: {formatDate(singleProjectData?.testEndDate)}
                  </div>
                </div>
                <div className="isecurion_single_project_dates">
                  <div className="isecurion_single_project_details">
                    <div className="pro_content" ref={statusRef}>
                      <button className='edit_option'>
                        {isEditing ? (
                          <CustomSelect style={{ border: "1px solid #cdc0c0" }}
                            placeholder="Select"
                            options={
                              ['Select', 'Retesting', 'Completed']
                            }
                            value={selectedOption}
                            onChange={(option) => {
                              setSelectedOption(option)
                              handleSaveClick(singleProjectData._id, option)
                            }}
                          />
                        ) : (
                          <p className={getStatus(singleProjectData?.status)}>
                            {singleProjectData?.status}
                          </p>
                        )}
                      </button>
                      {buttonVisible && (
                        <i className="isecurion_icon" onClick={() => handleEditClick()}>
                          <FontAwesomeIcon icon={faPenToSquare} />
                        </i>
                      )}
                    </div>
                  </div>
                </div>
              </div>


            </div>
            <div className="isecurion_single_project_manager_matrix_container">
              <div className="isecurion_single_project_manager_matrix_heading">
                Vulnerability Risk Rate Matrix and Status Distribution
              </div>

              <div className="isecurion_single_project_manager_matrix_Inner_container">
                <div className="isecurion_single_project_manager_matrix_bubble isecurion_single_project_manager_matrix_critical">
                  Critical
                  <br />
                  <span>{severityCount.Critical}</span>
                </div>
                <div className="isecurion_single_project_manager_matrix_bubble isecurion_single_project_manager_matrix_high">
                  High
                  <br />
                  <span>{severityCount.High}</span>
                </div>
                <div className="isecurion_single_project_manager_matrix_bubble isecurion_single_project_manager_matrix_medium">
                  Medium
                  <br />
                  <span>{severityCount.Medium}</span>
                </div>
                <div className="isecurion_single_project_manager_matrix_bubble isecurion_single_project_manager_matrix_low">
                  Low
                  <br />
                  <span>{severityCount.Low}</span>
                </div>
                <div className="isecurion_single_project_manager_matrix_bubble isecurion_single_project_manager_matrix_info">
                  Info
                  <br />
                  <span>{severityCount.Info}</span>
                </div>
                <div className="isecurion_single_project_manager_matrix_bubble isecurion_single_project_manager_matrix_fixed">
                  Fixed
                  <br />
                  <span>{retestCount.Fixed}</span>
                </div>
                <div className="isecurion_single_project_manager_matrix_bubble isecurion_single_project_manager_matrix_not_fixed">
                  Not Fixed
                  <br />
                  <span>{retestCount.Not_Fixed}</span>
                </div>
                <div className="isecurion_single_project_manager_matrix_bubble isecurion_single_project_manager_matrix_not_applicable">
                  Not Applicable
                  <br />
                  <span>{retestCount.NA}</span>
                </div>
              </div>
            </div>
          </div>

          {/* security analyst resource and project conclusion */}
          <div className="isecurion_single_project_manager_resources_and_project_conclusion_container">
            <div className="isecurion_single_project_manager_resources_container">
              <div className="isecurion_single_project_manager_resources_heading">
                Resources
              </div>
              <div className="isecurion_single_project_manager_resources_table_container">
                <table>
                  <thead>
                    <tr>
                      <th>SI No</th>
                      <th>Name</th>
                      <th>Role</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1</td>
                      <td>{singleProjectData?.teamLead}</td>
                      <td>Audit Lead</td>

                    </tr>
                    {singleProjectData?.pentesters?.length > 0 ? (singleProjectData?.pentesters?.map((pentester, index) => (
                      <tr key={pentester._id || index}>
                        <td>{index + 2}</td>
                        <td>{pentester}</td>
                        <td>Security Analyst</td>
                      </tr>
                    ))) : ("")}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="isecurion_single_project_manager_conclusion_container">
              <div className="isecurion_single_project_manager_conclusion_heading">
                Activity Snapshot
              </div>

              <div className="isecurion_single_project_manager_conclusion_content_container">
                <div className="isecurion_single_project_manager_conclusion_content">
                  Coming Soon
                </div>

              </div>
            </div>
          </div>

          {/* Action */}
          <div className="isecurion_single_project_manager_action_container">
            <div className="isecurion_single_project_manager_action_heading">
              Actions
            </div>
            <div className="isecurion_single_project_manager_action_body">
              <button>
                <span>
                  <Icon icon="mingcute:report-fill" width="19" height="19" />
                  <span>Escalate Critical Issue</span>
                </span>
              </button>
              <button onClick={() => setRetestRequest(true)}>
                <span>
                  <Icon icon="mingcute:recycle-line" width="19" height="19" />
                  <span>Request Retest</span>
                </span>
              </button>
              <button>
                <span>
                  <Icon icon="gridicons:speaker" width="19" height="19" />
                  <span>Request Update</span>
                </span>
              </button>
            </div>
          </div>

          <RetestRequestSideBar
            retestRequest={retestRequest}
            setRetestRequest={setRetestRequest} />
        </>
      ) : (
        // security analyst assessment overview
        <div className="isecurion_single_project_description_and_pentester_container">
          <div className="isecurion_single_project_description_container">
            <div className="isecurion_single_project_description_heading">
              {singleProjectData?.projectName}
            </div>

            <div className="isecurion_single_project_details_container">
              <div className="isecurion_single_project_details">
                <span>Application Type : {singleProjectData?.applicationType}</span>
                <span>Report Type : {singleProjectData?.projectType}</span>
                <span>Environment Type : {singleProjectData?.environmentType}</span>
                <span>Team Lead : {singleProjectData?.teamLead}</span>
                <span>Client Name : {singleProjectData?.clientName}</span>
                <span>Client Lead : {singleProjectData?.clientManagerName}</span>
                <span>Client Type : {singleProjectData?.clientType}</span>
                <span>Test Start Date : {formatDate(singleProjectData?.testStartDate)}</span>
                <span>End Date : {formatDate(singleProjectData?.testEndDate)}</span>
              </div>
              <div className="isecurion_single_project_dates">
                <div className="isecurion_single_project_details">
                  <div className="pro_content" ref={statusRef}>
                    <button className='edit_option'>
                      {isEditing ? (
                        <CustomSelect style={{ border: "1px solid #cdc0c0" }}
                          placeholder="Select"
                          options={
                            ['Select', 'Retesting', 'Completed']
                          }

                          value={selectedOption}
                          onChange={(option) => {
                            setSelectedOption(option)
                            handleSaveClick(singleProjectData._id, option)
                          }}
                        />
                      ) : (
                        <p className={getStatus(singleProjectData?.status)}>
                          {singleProjectData?.status}
                        </p>
                      )}
                    </button>
                    {buttonVisible && (
                      <i className="isecurion_icon" onClick={() => handleEditClick()}>
                        <FontAwesomeIcon icon={faPenToSquare} />
                      </i>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="isecurion_single_project_pentester_container">
            <div className="wrap_assign_pentester_heading">
              <div className="isecurion_single_project_pentester_heading">
                Pentesters
              </div>
              <div>
                <button onClick={() => setOpenAddPentester(true)}>Assign Pentester</button>
              </div>
            </div>
            {openAddPentester ? (
              <div>
                <div className='wrap_input_assigner'>

                  <input
                    type="text"
                    placeholder="Enter full name"
                    value={penTesters}
                    ref={inputRef}
                    onChange={handleEmployeeChange}
                  />
                  {filteredSuggestions.length > 0 && (
                    <ul className="suggestions_employee" ref={suggestionsRef}>
                      {filteredSuggestions.map((suggestion, index) => (
                        <li key={index} onClick={() => handleSuggestionClick(suggestion)}>
                          {suggestion}
                        </li>
                      ))}
                    </ul>
                  )}

                </div>
                <div className="wrap_cancel_assign_buttons">
                  <button className="wrap_cancel_pentester_button" onClick={() => {
                    setPenTesters('')
                    setFilteredSuggestions([]);
                    setOpenAddPentester(false)
                  }}>Cancel</button>
                  <button className="wrap_assign_pentester_button" onClick={handlePentesters}>Assign</button>
                </div>
              </div>
            ) : (
              <div className="isecurion_single_project_pentester_table">
                <table>
                  <thead>
                    <tr>
                      <th>SI No</th>
                      <th>Name</th>
                      <th>E-mail ID</th>
                    </tr>
                  </thead>
                  <tbody>
                    {testersData.length > 0 ? testersData?.map((data, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{data.name}</td>
                        <td>{data.email}</td>
                      </tr>
                    )) : (
                      <tr><td style={{ color: 'red', textAlign: 'center' }} colSpan={3}>No records found</td></tr>
                    )}

                  </tbody>
                </table>
              </div>
            )}

          </div>
          {loading && (
            <div className='waiting_page'>
              <div className='wrap_Waiting_loader'>
                <span className="loader"></span>
              </div>
            </div>
          )}
        </div>
      );
    case "scope":
      return (
        <div className="isecurion_single_project_scope_container">
          <div className="isecurion_single_project_scope_testing_targets_container">
            <div className="isecurion_single_project_scope_testing_targets_heading">
              Testing Targets
            </div>
            {singleProjectData ? (
              <div className='isecurion_single_project_scope_testing_targets_item'>
                <div className='wrap_application_details'>
                  <h5>
                    {singleProjectData?.applicationType !== 'VA Scan' &&
                      singleProjectData?.applicationType !== 'Configuration Review' &&
                      singleProjectData?.applicationType !== 'External Network Penetration Testing' &&
                      singleProjectData?.applicationType !== 'Internal Network Penetration Testing'
                      ? `${singleProjectData?.applicationType} Application`
                      : singleProjectData?.applicationType}
                  </h5>

                  <p>{singleProjectData?.applicationType !== 'VA Scan' && singleProjectData?.applicationType !== 'Configuration Review' && singleProjectData?.applicationType !== 'External Network Penetration Testing' && singleProjectData?.applicationType !== 'Internal Network Penetration Testing' ? (singleProjectData?.scope) : ''}</p>
                </div>
                <div className='wrap_status_application_scope'>
                  <button className={getScopeStatus(singleProjectData?.status)}>
                    {
                      singleProjectData?.status === 'Inprogress' ? 'In Progress' : singleProjectData?.status
                    }
                  </button>
                </div>

              </div>
            ) : (
              <div style={{ display: 'flex', justifyContent: 'center', marginTop: '50px' }}>
                <img style={{ width: "80px", height: "80px" }} src={target} alt='Vulnytics - Pentest as a service' />
              </div>
            )}
            {singleProjectData?.applicationType !== 'VA Scan' && singleProjectData?.applicationType !== 'Configuration Review' && singleProjectData?.applicationType !== 'External Network Penetration Testing' && singleProjectData?.applicationType !== 'Internal Network Penetration Testing' ? '' : (
              <div className='wrap_scope_tables'>
                {Array.isArray(previewCols) && previewCols.length === 0 ? (
                  <div>
                    <p style={{ marginTop: '40px', color: 'red' }}>No Records Found</p>
                  </div>
                ) : (
                  <>
                    <div className='wrap_inside_scope_table'>
                      <table>
                        <thead>
                          <tr>
                            {previewCols.map((col, i) => (
                              <th style={{
                                wordBreak: "break-word",
                                width: `${100 / previewCols.length}%`,
                                padding: "6px",
                              }}
                                key={i}>
                                {col || "-"}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {previewRows.map((row, i) => (
                            <tr key={i}>
                              {previewCols.map((col, j) => (
                                <td key={j}>
                                  {row[col] || "-"}
                                </td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    <div className="wrap_scope_read_more">
                      {rows.length > 0 &&
                        (rows.length > 3 || Object.keys(rows[0] || {}).length > 2) && (
                          <button onClick={() => setShowModal(true)}>
                            Read More
                          </button>
                        )}
                    </div>

                    {showModal && (
                      <div className='wrap_scope_full_content'>
                        <div className='wrap_scope_content_details'>
                          <div className='wrap_file_name_heading'>
                            <h2>{scopeFileName}</h2>
                            <p onClick={() => setShowModal(false)}>X</p>
                          </div>

                          <div className='wrap_scope_content_table'>
                            <table>
                              <thead>
                                <tr>
                                  {Object.keys(rows[0]).map((col, i) => {
                                    const colName = col?.toString().toLowerCase().trim();
                                    const isSerialCol = ["sl.no", "sl no", "no", "#", "number", "no.", "num", "sl no.", "sl.no.", "slno", "sno",].includes(colName);

                                    return (
                                      <th
                                        key={i}
                                        style={{
                                          width: isSerialCol ? "80px" : "auto",
                                          wordBreak: "break-word",
                                          padding: "6px",
                                        }}
                                      >
                                        {col}
                                      </th>
                                    );
                                  })}
                                </tr>
                              </thead>
                              <tbody>
                                {rows.map((row, i) => (
                                  <tr key={i}>
                                    {Object.entries(row).map(([col, val], j) => {
                                      const colName = col?.toString().toLowerCase().trim();
                                      const isSerialCol = ["sl.no", "sl no", "no", "#", "number", "no.", "num", "sl no.", "sl.no.", "slno", "sno",].includes(colName);

                                      return (
                                        <td
                                          key={j}
                                          style={{
                                            width: isSerialCol ? "80px" : "auto",
                                          }}
                                        >
                                          {val || "-"}
                                        </td>
                                      );
                                    })}
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>


                        </div>
                      </div>
                    )}</>

                )}

              </div>
            )}
          </div>

          <div className="isecurion_single_project_scope_testing_methodology_container">
            <div className="isecurion_single_project_scope_testing_methodology_heading">
              Testing Methodology
            </div>
            <div className="isecurion_single_project_scope_testing_methodology_standard_framework">
              Standards & Framework
            </div>

            <div className='wrap_frameworks'>
              {singleProjectData?.applicationType === 'IOS' || singleProjectData?.applicationType === 'ANDROID' || singleProjectData?.applicationType === 'ANDROID & IOS' || singleProjectData?.applicationType === 'WEB' || singleProjectData?.applicationType === 'API' || singleProjectData?.applicationType === 'Desktop App' ? <h3>OWASP Top 10</h3> : ''}
              {singleProjectData?.applicationType === 'WEB' || singleProjectData?.applicationType === 'API' ? <h3>Nist Framework</h3> : ''}
              {singleProjectData?.applicationType === 'WEB' ? <h3>Custom Checks</h3> : ''}
              {singleProjectData?.applicationType === 'Secure Code Review' ? <h3>OWASP Code Review</h3> : ''}
              {singleProjectData?.applicationType === 'Secure Code Review' ? <h3>CERT</h3> : ''}
              {singleProjectData?.applicationType === 'Secure Code Review' ? <h3>SANS Top 25</h3> : ''}
              {singleProjectData?.applicationType === 'IOS' || singleProjectData?.applicationType === 'ANDROID' || singleProjectData?.applicationType === 'ANDROID & IOS' ? <h3>MSTG</h3> : ''}
              {singleProjectData?.applicationType === 'IOS' || singleProjectData?.applicationType === 'ANDROID' || singleProjectData?.applicationType === 'ANDROID & IOS' ? <h3>SANS-25</h3> : ''}
              {singleProjectData?.applicationType === 'IOS' || singleProjectData?.applicationType === 'ANDROID' || singleProjectData?.applicationType === 'ANDROID & IOS' ? <h3>MASVS</h3> : ''}
              {[
                "VA Scan",
                "Configuration Review",
                "External Network Penetration Testing",
                "Internal Network Penetration Testing"
              ].includes(singleProjectData?.applicationType) && (
                  <>
                    <h3>OWASP</h3>
                    <h3>PTES</h3>
                    <h3>OSSTMM</h3>
                    <h3>NIST</h3>
                  </>
                )}

            </div>
          </div>
        </div>
      );
    case "vulnerabilities":
      return (
        <div className="isecurion_single_project_vulnerabilities_container">
          <div className="isecurion_single_project_vulnerabilities_heading">
            Discovered Vulnerabilities
          </div>

          <div className="isecurion_single_project_vulnerabilities_detailed_list_heading">
            Detailed list of all security vulnerabilities found during testing
          </div>

          <div className="isecurion_table_wrapper">
            <div className="isecurion_single_project_vulnerabilities_table_container">
              <div className="isecurion_table_wrapper">
                <table className="isecurion_table">
                  <thead>
                    <tr>
                      <th className="sino">SI No</th>
                      <th className="vulnerability_Name">Vulnerability Name</th>
                      <th className="severity">Severity</th>
                      <th className="uploadedby">Uploaded By</th>
                      {/* <th className="uploadedat">Uploaded At</th> */}
                      {singleProjectData?.status !== "Inprogress" && (
                        <th className="resetstatus">Retest Status</th>
                      )}
                      <th className="actions">Actions</th>
                    </tr>
                  </thead>

                  <tbody>
                    {vulnerabilities &&
                      [...vulnerabilities]
                        .sort((a, b) => {
                          const order = ["critical", "high", "medium", "low", "info"];
                          return (
                            order.indexOf(a.severity.toLowerCase()) -
                            order.indexOf(b.severity.toLowerCase())
                          );
                        })
                        .map((vul, index) => (
                          <tr key={index}>

                            {/* index No  */}
                            <td>{index + 1}</td>

                            {/* 1. Vulnerability Name */}
                            <td>{vul.vulnerabilityName}</td>

                            {/* 2. Severity */}
                            <td>
                              <span
                                className={`isecurion_single_project_vulnerabilities_detailed_list_item_badge status-${vul.severity
                                  .toLowerCase()
                                  .replace(/\s/g, "")}`}
                              >
                                {vul.severity}
                              </span>
                            </td>

                            {/* 3. Uploaded By */}
                            <td >{vul.addedby || "-"}</td>

                            {singleProjectData?.status !== "Inprogress" && (
                              <td>
                                {editingVulId === vul._id ? (
                                  <CustomSelect
                                    style={{ border: "1px solid #cdc0c0" }}
                                    placeholder="Select"
                                    options={["NA", "Fixed", "Not Fixed"]}
                                    value={selectedOption}
                                    onChange={(option) => {
                                      setRetestSelectedOption(option);
                                      handleRetestSave(vul._id, option);
                                    }}
                                  />
                                ) : (
                                  <div className="flex items-center gap-2">
                                    <span
                                      className={`isecurion_single_project_vulnerabilities_detailed_list_item_badge retest-status-${vul.retestStatus?.replace(
                                        /\s+/g,
                                        ""
                                      )}`}
                                    >
                                      {/* {console.log(vul.retestStatus)} */}
                                      {vul.retestStatus ? vul.retestStatus : ""}
                                    </span>

                                    <i
                                      className="isecurion_icon"
                                      onClick={() => handleRetestEditClick(vul._id)}
                                    >
                                      <FontAwesomeIcon icon={faPenToSquare} />
                                    </i>
                                  </div>
                                )}
                              </td>
                            )}

                            <td>

                              <button
                                className="button_delete_vul_isecurion"
                                onClick={() => {
                                  setSelectedVulId(vul._id);
                                  setDeleteModalOpen(true);
                                }}
                              >
                                <Icon icon="material-symbols:delete-outline" width="20" height="20" />
                              </button>

                              <button
                                className="button_edit_vul_isecurion"
                                onClick={() => handleEditVulnerability(vul._id)}
                              >
                                <Icon icon="ic:round-edit-note" width="24" height="24" />
                              </button>
                              <button
                                onMouseEnter={() => setHoveredIndex(index)}
                                onMouseLeave={() => setHoveredIndex(null)}
                              >
                                <Link to={`/isecurion/viewvulnerabilities/${vul._id}`}>
                                  <Icon
                                    icon={hoveredIndex === index ? 'iconamoon:eye-light' : 'humbleicons:eye-close'}
                                    width="20"
                                    height="20"
                                    color="#E76A34"
                                  />
                                </Link>
                              </button>
                            </td>
                          </tr>
                        ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>


          {
            deleteModalOpen && (
              <div className="delete-container">
                <div className="delete-content">
                  <div className="delete-header">
                    <p>Delete Vulnerability</p>
                  </div>

                  <div className="delete-body">
                    <div className="delete-message">
                      <p>Are you sure you want to delete this vulnerability?</p>
                    </div>

                    <div className="delete-buttons">
                      <button
                        className="delete-btn cancel"
                        onClick={() => {
                          setDeleteModalOpen(false);
                          setSelectedVulId(null);
                        }}
                      >
                        Cancel
                      </button>

                      <button
                        className="delete-btn confirm"
                        onClick={handleDeleteVulnerability}
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )
          }
        </div >
      );
    case "reports":
      return (
        <div className="isecurion_single_project_report_container">
          <div className="isecurion_single_project_report_heading">
            Export Report
          </div>

          <div className="isecurion_single_project_report_description">
            Upload new reports
          </div>

          <div className="isecurion_single_project_report_upload_container"
            onDragEnter={handleDragEnter}
            onDragOver={handleDragEnter}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}>
            <div>
              <h2 style={{ wordBreak: 'break-word', color: "rgba(5, 5, 5, 0.51)", fontSize: "18px" }}>{file ? file.name : null}</h2>
            </div>
            <div className="isecurion_single_project_report_upload_heading">
              {dragging ? 'Drop to upload' : 'Drag and drop files here'}
            </div>
            <div className="isecurion_single_project_report_upload">
              <input
                type="file"
                id="fileInput"
                accept=".pdf,.xlsx"
                onChange={handleFileInputChange}
                style={{ display: "none" }}
              />
              {file && file ? (
                <button onClick={handleFileUpload}
                  style={{ padding: "7px 16px" }}
                  className="isecurion_single_project_report_custom_file_upload"
                  type="button"
                >
                  Upload
                </button>
              ) : (
                <label style={{ cursor: 'pointer', padding: "6px 14px" }} htmlFor="fileInput" className="isecurion_single_project_report_custom_file_upload">
                  <Icon icon="lucide:files" width="24" height="24" />
                  Choose File
                </label>
              )}

            </div>
            <div className="isecurion_single_project_report_upload_condition_statement">
              {dragging ? 'Upload only PDF and Excel formatted documents' : 'Upload only PDF and Excel formatted documents'}
            </div>
          </div>

          <div className="isecurion_single_project_report_table_container">
            <table>
              <thead>
                <tr>
                  <th>Sl No.</th>
                  <th>File Name</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {allDoc.length === 0 ? (
                  <tr>
                    <td colSpan={"3"}>No Documents</td>
                  </tr>
                ) : (
                  allDoc.map((doc, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{doc.fileName}</td>
                      <td>
                        <span onClick={() => {
                          setSelectedFileName(doc.fileName);
                          setConfirmDelete(true)
                        }
                        }><Icon icon="material-symbols:delete-outline" width="24" height="24" color="red" /></span>
                        <span onClick={() => handleReportDownload(doc.fileName)} style={{ marginLeft: "30px", cursor: "pointer" }} ><Icon icon="tabler:download" width="24" height="24" color="blue" /></span>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div >
          {confirmDelete && (
            <DeleteReport
              selectedFileName={selectedFileName}
              fetchDocument={fetchDocument}
              confirmDelete={confirmDelete}
              setConfirmDelete={setConfirmDelete}
              singleProjectData={singleProjectData}
            />
          )}
        </div >
      );
    case "team":
      return (
        <div className="isecurion_single_project_team_container">
          <div className="isecurion_single_project_team_heading">
            Security Analyst
          </div>
          <div className="isecurion_single_project_team_description">
            Security professionals working on your project
          </div>

          <div className="isecurion_single_project_team_members_container">
            <div className="isecurion_single_project_team_card_container">
              <div className="isecurion_single_project_team_card_half_details" style={{ marginRight: "10px" }}>
                <div className="isecurion_single_project_team_card_profile_icon"> {singleProjectData?.teamLead.charAt(0).toUpperCase()}</div>
                <div className="isecurion_single_project_team_card_details">
                  <div className="isecurion_single_project_team_card_name">
                    {singleProjectData?.teamLead}
                  </div>
                  <div className="isecurion_single_project_team_card_role">
                    Project Lead
                  </div>
                </div>
              </div>
            </div>
            <TeamCard singleProjectData={singleProjectData} />

          </div>
        </div>
      );

    default:
      return;
  }
}

export default ProjectTabContent;